import React from 'react';
import styled from 'styled-components';

// width and height set in parent styles, do not set it here
const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  font: ${props => props.theme.fontWeightHeavy} 19px/120% ${props => props.theme.fontFamilyBody};
  color: #627484;
`;

const SubTitle = styled.div`
  font: ${props => props.theme.fontWeightRegular} 16px/120% ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.secondaryColor};
  margin-top: 8px;
  max-width: 340px;
`;

function Description() {
  return (
    <Container>
      <Title>How are my contributors ranking against all Livewire contributors?</Title>
      <SubTitle>Rank is based on the number of followers.</SubTitle>
    </Container>
  );
}

export default React.memo(Description);
